import routes from './routes'
import * as links from './links'
import * as components from './components'

export default {
  components,
  links,
  routes
}



// WEBPACK FOOTER //
// ./src/features/Feedback/index.js